import dayjs from "dayjs";

export const getDefaultRange = () => {
  const start = dayjs().startOf("month");
  const end = start.clone().add(1, "month").endOf("D");
  return [start.toDate(), end.toDate()];
};
